import { client } from '../client';
import { IMedia } from './types/IMedia';
import { getStaffScopedApiPrefix } from '@brands/Utils/staffScopedApiPrefix';

export const getOneReportMedia = async (media_id: string, userRole?: string): Promise<IMedia> => {
  const prefix = getStaffScopedApiPrefix(userRole);
  const { data } = await client.get(`${prefix}/media/${media_id}`);
  return data;
};
